import { MaxOmissionsSetting } from "./OmissionsModule-Types";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { debounce } from "@mui/material";
const debouncedRecipeRefresh = debounce((dispatch) => {
    dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
}, 1000);
export const handleCheckboxChange = (OmissionsToDisplay, dispatch, storeCartOmissions, toast, maximumOmissionsSettings, softMaxValue, softWarningText, hardMaxValue, hardWarningText, checkedCount) => (categoryId, NoCategoryText) => (event) => {
    const omissionDislikeId = event.target.name;
    const category = OmissionsToDisplay.find((category) => category.categoryId === categoryId);
    const dislike = category === null || category === void 0 ? void 0 : category.dislikes.find((dislike) => dislike.dislikeId === Number(omissionDislikeId));
    const newOmission = category && dislike
        ? {
            categoryId: category.categoryId,
            categoryName: category.categoryId === 0 ? NoCategoryText : category.categoryName,
            dislikeId: dislike === null || dislike === void 0 ? void 0 : dislike.dislikeId,
            dislikeName: dislike === null || dislike === void 0 ? void 0 : dislike.dislikeName,
            AllowedRecipeTypes: dislike === null || dislike === void 0 ? void 0 : dislike.AllowedRecipeTypes,
        }
        : undefined;
    if (newOmission) {
        if (event.target.checked) {
            handleWarnings(maximumOmissionsSettings, softMaxValue, softWarningText, hardMaxValue, hardWarningText, toast, checkedCount);
            dispatch({ type: ActionTypes.SET_OMISSIONS, payload: [...storeCartOmissions, newOmission] });
            debouncedRecipeRefresh(dispatch);
        }
        else {
            const tempArray = [...storeCartOmissions];
            const index = tempArray.findIndex((omission) => omission.dislikeId === newOmission.dislikeId && omission.categoryId === newOmission.categoryId);
            tempArray.splice(index, 1);
            dispatch({ type: ActionTypes.SET_OMISSIONS, payload: [...tempArray] });
            debouncedRecipeRefresh(dispatch);
        }
    }
};
export const handleWarnings = (maximumOmissionsSettings, softMaxValue, softWarningText, hardMaxValue, hardWarningText, toast, checkedCount) => {
    if (maximumOmissionsSettings === MaxOmissionsSetting.NONE)
        return;
    if ((maximumOmissionsSettings === MaxOmissionsSetting.SOFT || maximumOmissionsSettings === MaxOmissionsSetting.BOTH) && (checkedCount + 1 == softMaxValue)) {
        toast.push(softWarningText, { variant: "default" });
    }
    if ((maximumOmissionsSettings === MaxOmissionsSetting.HARD || maximumOmissionsSettings === MaxOmissionsSetting.BOTH) && (checkedCount + 1 == hardMaxValue)) {
        toast.push(hardWarningText, { variant: "default" });
    }
};
const isOmissionRequired = (categoryId, dislikeId, OmissionsToDisplay) => {
    const category = OmissionsToDisplay.find((category) => category.categoryId === categoryId);
    const omission = category === null || category === void 0 ? void 0 : category.dislikes.find((omission) => omission.dislikeId === dislikeId);
    return omission === null || omission === void 0 ? void 0 : omission.required;
};
export const isOmissionDisabled = (OmissionsToDisplay, UsesMaxOmissions, MaxOmissions, checkedCount, storeCartOmissions) => (categoryId, dislikeId) => {
    if (isOmissionRequired(categoryId, dislikeId, OmissionsToDisplay))
        return true;
    // if we're using MaxOmissions, and checkedCount >= MaxOmissions, and
    // the omission is not already checked, disable.
    if (UsesMaxOmissions) {
        if (checkedCount >= MaxOmissions &&
            storeCartOmissions &&
            !storeCartOmissions.find((o) => o.dislikeId === dislikeId)) {
            return true;
        }
    }
    return false;
};
// Counts the number of omissions in each category.
export const countSelectedByCategory = (arr) => {
    const dictionary = {};
    // For each element in the array, check if there is a dictionary key for that id. If there is no key, create it with a value(count) of one.
    // Otherwise, increment the count by one.
    arr.forEach((a) => (!dictionary[a.categoryId] ? (dictionary[a.categoryId] = 1) : (dictionary[a.categoryId] += 1)));
    return dictionary;
};
